<template>
    <div id="contig_table">
        <h1>Contig Table</h1>

        <div v-if="table">
            <b-pagination
            v-model="page"
            :total-rows="pages"
            limit="10"
            per-page="1"
            @input="load_data"
            :disabled="pagination_disable"
            align="fill">
            </b-pagination>
            <b-table striped hover :items="table" :fields="fields">
                <template v-slot:cell(contig_id)="row">
                    <router-link :to="{path: `/contig/${row.item['id']}`}">{{row.value}}</router-link>
                </template>
                <template v-slot:cell(experiment_id)="row">
                    <router-link :to="{path: `/exp/${row.value}`}">{{row.value}}</router-link>
                </template>

            </b-table>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    export default {
        name: "ContigTable",
        data: function () {
            return {
                table: undefined,
                fields: ['contig_id', 'experiment_id', 'length'],
                page: 1,
                pages: undefined,
                pagination_disable: false,
            }
        },
        props: ['search_data'],
        mounted() {
            if (this.$store.state.search_data === undefined) {
                this.load_data(this.page)
            }
            else {
                this.table = this.$store.state.search_data;
                this.pages = 1;
                this.pagination_disable = false;
                this.$store.dispatch('clear_data_search');
            }
        },
        methods: {
            async load_data(page) {
                this.pagination_disable = true;
                await this.$nextTick();
                axios.get(`/get/contigs/${page}`)
                    .then(response => {
                        this.table = response.data['value'];
                        this.pages = response.data['pages'];
                        this.pagination_disable = false;
                    })
            }
        }
    }
</script>

<style scoped>

</style>